import { supabase } from '../lib/supabase';

export const notificationService = {
  // Get notifications for user
  async getNotifications(userId) {
    const { data, error } = await supabase?.from('notifications')?.select('*')?.eq('user_id', userId)?.order('created_at', { ascending: false });
    
    // Gracefully handle missing table (PGRST205 error)
    if (error) {
      if (error?.code === 'PGRST205') {
        console.warn('Notifications table not found. Please apply Supabase migration.');
        return [];
      }
      throw error;
    }
    
    return data?.map(notif => ({
      id: notif?.id,
      userId: notif?.user_id,
      notificationType: notif?.notification_type,
      title: notif?.title,
      message: notif?.message,
      observation: notif?.observation,
      recommendation: notif?.recommendation,
      withdrawalId: notif?.withdrawal_id,
      isRead: notif?.is_read,
      createdAt: notif?.created_at
    }));
  },

  // Get unread notification count
  async getUnreadCount(userId) {
    const { count, error } = await supabase?.from('notifications')?.select('*', { count: 'exact', head: true })?.eq('user_id', userId)?.eq('is_read', false);
    
    // Gracefully handle missing table
    if (error) {
      if (error?.code === 'PGRST205') {
        return 0;
      }
      throw error;
    }
    return count || 0;
  },

  // Mark notification as read
  async markAsRead(notificationId) {
    const { error } = await supabase?.from('notifications')?.update({ is_read: true })?.eq('id', notificationId);
    
    // Gracefully handle missing table
    if (error && error?.code === 'PGRST205') {
      return;
    }
    if (error) throw error;
  },

  // Mark all notifications as read
  async markAllAsRead(userId) {
    const { error } = await supabase?.from('notifications')?.update({ is_read: true })?.eq('user_id', userId)?.eq('is_read', false);
    
    // Gracefully handle missing table
    if (error && error?.code === 'PGRST205') {
      return;
    }
    if (error) throw error;
  }
};
